module.exports = __webpack_public_path__ + "img/th.62f0033c.svg";